const initialState = {
  tokenNumber: null,
  tokenId: null,
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BOOKING_DETAILS":
      const {uuid, tokenNumber} = action?.payload?.data;
      return {
        ...state,
        tokenNumber: tokenNumber,
        tokenId: uuid,
      };
    default:
      return state;
  }
};

export default bookingReducer;
